import Base from '../Base';
export default class SingleGrandsProjets extends Base {
    init(id, main, locale) {
        console.log(':: SingleGrandsProjets ::');

        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 15,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 15,
            loop: true,
            thumbs: {
                swiper: galleryThumbs,
            },
          
        });

    

        galleryTop.on('realIndexChange', e => {
            var galleryParent = document.querySelector('.gallery-top').parentElement;

            Array.from(galleryParent.querySelectorAll('.img-source')).forEach(el => {
                el.classList.remove('active');
            });

            galleryParent.querySelector(`[data-index-source="${e.realIndex}"]`).classList.add('active');
        });

        if( document.querySelector('.gallery-next')){
            document.querySelector('.gallery-next').addEventListener('click', e => {
                galleryTop.slideNext();
            });
        }
       
        if( document.querySelector('.gallery-prev')){
            document.querySelector('.gallery-prev').addEventListener('click', e => {
                galleryTop.slidePrev();
            });
        }
      

     

        var sliderObject = document.querySelector('#otherProjects_slider');
        if (sliderObject){
            var order_object = sliderObject.dataset.order;
            var orderCount = document.getElementById('wrapperOtherProjects').childElementCount;
            var startAt = order_object - 1;
            var startAtMobile = order_object - 1;
        }

        if (startAt == 0) {
            startAt = orderCount - 1;
        } else {
            startAt -= 1;
        }

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') {
              const galleryNextButton = document.querySelector('.gallery-next');
              const galleryPrevButton = document.querySelector('.gallery-prev');
      
              if (event.target === galleryNextButton) {
                  galleryTop.slideNext();
              } else if (event.target === galleryPrevButton) {
                  galleryTop.slidePrev();
              }
          }
      });

        var swiper = new Swiper('.otherProjects-container', {
            slidesPerView: 1,
            spaceBetween: 40,
            allowTouchMove: true,
            preventClicks: false,
            preventClicksPropagation: false,
            initialSlide: startAtMobile,
            loop: true,

            breakpoints: {
                992: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    allowTouchMove: false,
                    initialSlide: startAt,
                    preventClicks: false,
                    preventClicksPropagation: false,
                    simulateTouch: false,
                },
            },
         
        });

        if( document.querySelector('.otherProjects-next')){
            document.querySelector('.otherProjects-next').addEventListener('click', e => {
                swiper.slideNext();
            });
        }

       if(document.querySelector('.otherProjects-prev')){
            document.querySelector('.otherProjects-prev').addEventListener('click', e => {
                swiper.slidePrev();
            });
       }

       


    
      // Add resize event listener
      window.addEventListener('resize', ()=>{
          this.updateNavigationArrows();
      });

        var els = document.getElementsByClassName('graphImgContainer');

        Array.from(els).forEach(el => {
            el.addEventListener('scroll', () => {
                el.classList.add('scrollGraph');
            });
        });

        window.onload = function() {
            jQuery('.otherProjects-container .swiper-wrapper').each(function() {
                var highestBox = 0;
                jQuery('.swiper-slide', this).each(function() {
                    if (jQuery(this).height() > highestBox) {
                        highestBox = jQuery(this).height();
                    }
                });

                jQuery('.swiper-slide', this).height(highestBox);
            });
        };

        const scrollTopBtn = document.getElementById('scrollToTop');
        if (scrollTopBtn) {
            scrollTopBtn.addEventListener('click', e => {
                this.scroll(e);
            });
        }

        let listBtnArrow = document.querySelectorAll('.btn-arrow');
        for (const btnArrow of listBtnArrow) {
            btnArrow.addEventListener('click', e => {
                this.btnArrowClick(e);
            });
        }

        const tileSliders = document.querySelectorAll('.tile-slider');
        const tileSwipers = [];

        if (tileSliders) {
          tileSliders.forEach(slider => {
              var swipers = [
                  slider.querySelector('.tile-slider__hat'),
              ];
      
              const prevArrow = slider.querySelector('.swiper-button-prev');
              const nextArrow = slider.querySelector('.swiper-button-next');

              const allCtas = slider.querySelectorAll('a');
                    allCtas.forEach((cta) => {
                        cta.addEventListener('click',(e)=>{
                            const url = e.target.getAttribute("href");
                            const click_text = e.target.innerHTML;
                            const internal = e.target.getAttribute("target") === "_blank" ? false : true;

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                              event: "cta",
                              click_text: click_text,
                              click_url: url,
                              cta_type: 'slider timeline',
                              internal: internal
                            });
                        })
                    });
      
              const syncSlideChange = (direction) => {
                  tileSwipers.forEach(slider => {
                      if (direction === 'next') {
                          slider.slideNext();
                      } else {
                          slider.slidePrev();
                      }
                  });
              };
      
              swipers.forEach(function (swiperSelector, index) {
                  if (swiperSelector) {
                      tileSwipers.push(new Swiper(swiperSelector, {
                          speed: 753,
                          slidesPerView: 1,
                          spaceBetween: 35,
                          allowTouchMove: false,
                          breakpoints: {
                              1201: {
                                  slidesPerView: 4,
                                  spaceBetween: 35,
                                  slidesPerGroup: 4,
                              },
                              1200: {
                                  slidesPerView: 3,
                                  spaceBetween: 35,
                                  slidesPerGroup: 3,
                              },
                              992: {
                                  slidesPerView: 2,
                                  spaceBetween: 35,
                                  slidesPerGroup: 2,
                              },
                              576: {
                                  spaceBetween: 35,
                                  slidesPerView: 1,
                                  slidesPerGroup: 1,
                              }
                          }
                      }));
                  }
                  var topWrappers = swiperSelector.querySelectorAll('.top-wrapper');
                  var descWrappers = swiperSelector.querySelectorAll('.desc-wrapper');

                
                  var maxHeight = 0;
                  var maxHeightDesc = 0;
                  
             
                  topWrappers.forEach(function(wrapper) {
                      var wrapperHeight = wrapper.offsetHeight; 
                      if (wrapperHeight > maxHeight) {
                          maxHeight = wrapperHeight;
                      }
                  });

                  descWrappers.forEach(function(wrapper) {
                    var wrapperHeight = wrapper.offsetHeight; 
                    if (wrapperHeight > maxHeightDesc) {
                        maxHeightDesc = wrapperHeight; 
                    }

                    
                });
                  
                  topWrappers.forEach(function(wrapper) {
                      wrapper.style.minHeight = maxHeight + 'px';
                  });

                  descWrappers.forEach(function(wrapper) {
                    wrapper.style.minHeight = maxHeightDesc + 'px';
                });

                window.addEventListener('resize', function() {
                    topWrappers.forEach(function(wrapper) {
                        wrapper.style.minHeight = '0px';
                    });
                    descWrappers.forEach(function(wrapper) {
                        wrapper.style.minHeight = '0px';
                    });
                    var maxHeight = 0;
                    var maxHeightDesc = 0;
                    topWrappers.forEach(function(wrapper) {
                        var wrapperHeight = wrapper.offsetHeight; 
                        if (wrapperHeight > maxHeight) {
                            maxHeight = wrapperHeight;
                        }
                    });

                    descWrappers.forEach(function(wrapper) {
                        var wrapperHeight = wrapper.offsetHeight; 
                        if (wrapperHeight > maxHeightDesc) {
                            maxHeightDesc = wrapperHeight; 
                        }
                    });
                    topWrappers.forEach(function(wrapper) {
                        wrapper.style.minHeight = maxHeight + 'px';
                    });
                    descWrappers.forEach(function(wrapper) {
                        wrapper.style.minHeight = maxHeightDesc + 'px';
                    });
                });
              });
      
              if (prevArrow) {
                  prevArrow.addEventListener('click', function () {
                      syncSlideChange('prev');
                  });
              }
      
              if (nextArrow) {
                  nextArrow.addEventListener('click', function () {
                      syncSlideChange('next');
                  });
              }
      
              tileSwipers.forEach(function (slider) {
      
                  slider.on('slideChangeTransitionEnd', function () {
                      if (prevArrow) {
                          if (slider.isBeginning) {
                              prevArrow.classList.add('disabled');
                              prevArrow.setAttribute('disabled', 'true');
                          } else {
                              prevArrow.classList.remove('disabled');
                              prevArrow.removeAttribute('disabled');
                          }
                      }
      
                      if (nextArrow) {
                          if (slider.isEnd) {
                              nextArrow.classList.add('disabled');
                              nextArrow.setAttribute('disabled', 'true');
                          } else {
                              nextArrow.classList.remove('disabled');
                              nextArrow.removeAttribute('disabled');
                          }
                      }
                  });


                    slider.slides.forEach(function (slide) {
                        slide.removeAttribute('aria-label');
                    });

      
                  // Add focus event listener
                  document.addEventListener('focusin', function (event) {
                      if (event.target.closest('.swiper-slide')) {
                          const currentIndex = slider.activeIndex;
                          const focusedIndex = Array.from(event.target.closest('.swiper-slide').parentNode.children).indexOf(event.target.closest('.swiper-slide'));
                          const diff = focusedIndex - currentIndex;
                          if (diff !== 0) {
                              slider.slideTo(currentIndex + diff);
                          }
                      }
                  });
              });
          });
      }
      

        const relatedSliderNew = document.querySelectorAll('.related-slider');
        const relatedSwipers = [];

        if(relatedSliderNew){
          relatedSliderNew.forEach(slider => {            
            const prevArrow = slider.querySelector('.swiper-button-prev');
            const nextArrow = slider.querySelector('.swiper-button-next');
            const sliders = [];

            const allCtas = slider.querySelectorAll('a');

            allCtas.forEach((cta) => {

                cta.addEventListener('click',(e)=>{

                    const url = e.target.getAttribute("href");
                    const click_text = e.target.querySelector('.btn.btn--chevron-black').innerHTML;
                    const internal = e.target.getAttribute("target") === "_blank" ? false : true;
                    
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "cta",
                        click_text: click_text,
                        click_url: url,
                        cta_type: 'slider publication reliées',
                        internal: internal
                    });
                })
            });
            
            relatedSwipers.push(new Swiper(slider.querySelector('.swiper-container'), {
              speed: 753,
              slidesPerView: 1,
              spaceBetween: 35,
              allowTouchMove: false,
              breakpoints: {
                  993: {
                      slidesPerView: 3,
                      spaceBetween: 76,
                      slidesPerGroup: 3,
                  },
                  768: {
                      slidesPerView: 2,
                      spaceBetween: 76,
                      slidesPerGroup: 2,
                  },
                  560: {
                      spaceBetween: 76,
                      slidesPerView: 1,
                      slidesPerGroup: 1,
                  }
              }
            }));
            
            if (prevArrow) {
              prevArrow.addEventListener('click', function () {
                relatedSwipers.forEach(function (slider, index) {
                  setTimeout(() => {
                    slider.slidePrev();
                  }, 65 * index);
                });
              });
            }
            
            if (nextArrow) {
              nextArrow.addEventListener('click', function () {
                relatedSwipers.forEach(function (slider, index) {
                  setTimeout(() => {
                    slider.slideNext(); 
                  }, 65 * index);
                });
              });
            }
            
            relatedSwipers.forEach(function (slider) {
           
              slider.on('slideChangeTransitionEnd', function () {
                var activeIndex = slider.activeIndex;
                if (prevArrow) {
                  if (slider.isBeginning) {
                    prevArrow.classList.add('disabled');
                    prevArrow.setAttribute('disabled', 'true');
                  } else {
                    prevArrow.classList.remove('disabled');
                    prevArrow.removeAttribute('disabled');
                  }
                }
            
                if (nextArrow) {
                  if (slider.isEnd) {
                    nextArrow.classList.add('disabled');
                    nextArrow.setAttribute('disabled', 'true');
                  } else {
                    nextArrow.classList.remove('disabled');
                    nextArrow.removeAttribute('disabled');
                  }
                }
              }
              );
            });
          });

           
        }

        this.updateNavigationArrows();      
    }

    updateNavigationArrows(){
      const tileSliders = document.querySelectorAll('.tile-slider');
      const relatedSliderNew = document.querySelectorAll('.related-slider');

      if (tileSliders) {
          tileSliders.forEach(slider => {
              const prevArrow = slider.querySelector('.swiper-button-prev');
              const nextArrow = slider.querySelector('.swiper-button-next');

  
              if (prevArrow && nextArrow) {
                 if(window.innerWidth < 577){
                  if(slider.querySelector('.tile-slider__hat').querySelectorAll('.swiper-slide').length < 2){
                      prevArrow.classList.add('invisible');
                      nextArrow.classList.add('invisible');
                  }
                  else{
                      prevArrow.classList.remove('invisible');
                      nextArrow.classList.remove('invisible');
                  }
              }
            
                // else if(window.innerWidth < 993 && window.innerWidth >= 577){
                //     if(slider.querySelector('.tile-slider__hat').querySelectorAll('.swiper-slide').length < 3){
                //         prevArrow.classList.add('invisible');
                //         nextArrow.classList.add('invisible');
                //     }
                //     else{
                //         prevArrow.classList.remove('invisible');
                //         nextArrow.classList.remove('invisible');
                //     }

                // }
                else if(window.innerWidth < 1201 && window.innerWidth >= 993){
                  if(slider.querySelector('.tile-slider__hat').querySelectorAll('.swiper-slide').length < 3){
                      prevArrow.classList.add('invisible');
                      nextArrow.classList.add('invisible');
                  }
                  else{
                      prevArrow.classList.remove('invisible');
                      nextArrow.classList.remove('invisible');
                  }
              }
              
                else if(window.innerWidth >= 1201){
                  if(slider.querySelector('.tile-slider__hat').querySelectorAll('.swiper-slide').length < 5){
                    prevArrow.classList.add('invisible');
                    nextArrow.classList.add('invisible');
                  }
                  else{
                      prevArrow.classList.remove('invisible');
                      nextArrow.classList.remove('invisible');
                  }
                }
              }
          });
      }
  
      if (relatedSliderNew) {
        relatedSliderNew.forEach(slider => {
              const prevArrow = slider.querySelector('.swiper-button-prev');
              const nextArrow = slider.querySelector('.swiper-button-next');

  
              if (prevArrow && nextArrow) {
                 if(window.innerWidth < 768){
                  if(slider.querySelectorAll('.swiper-slide').length < 2){
                      prevArrow.classList.add('invisible');
                      nextArrow.classList.add('invisible');
                  }
                  else{
                      prevArrow.classList.remove('invisible');
                      nextArrow.classList.remove('invisible');
                  }
              }

              else  if(window.innerWidth >= 768 && window.innerWidth < 993){
                if(slider.querySelectorAll('.swiper-slide').length < 3){
                    prevArrow.classList.add('invisible');
                    nextArrow.classList.add('invisible');
                }
                else{
                    prevArrow.classList.remove('invisible');
                    nextArrow.classList.remove('invisible');
                }

              }
         
               
                else if(window.innerWidth >= 993){
                  if(slider.querySelectorAll('.swiper-slide').length < 4){
                    prevArrow.classList.add('invisible');
                    nextArrow.classList.add('invisible');
                  }
                  else{
                      prevArrow.classList.remove('invisible');
                      nextArrow.classList.remove('invisible');
                  }
                }
               
              }
          });
      }
  };

    btnArrowClick(e){
        let hrefContent = e.currentTarget.getAttribute('href').replace('#', '');

        if(hrefContent.startsWith('green-acc')){
            let accToOpen = document.getElementById(hrefContent);
            let accHeaderBtn = accToOpen.querySelector('.greenAcc-header').querySelector('.btn-link');
            let accBody = accToOpen.querySelector('.green-acc-collapser');
            accHeaderBtn.classList.remove('collapsed');
            accHeaderBtn.setAttribute('aria-expanded', 'true');
            accBody.classList.add('show');
        }
    }

    scroll(e){
        e.preventDefault();
        var id = e.currentTarget.getAttribute('href').replace('#', '');
        var target = document.getElementById(id).getBoundingClientRect().top;
        this.animateScroll(target);
    }

    animateScroll(targetHeight, callback) {

        targetHeight = document.body.scrollHeight - window.innerHeight > targetHeight + scrollY
            ? targetHeight : document.body.scrollHeight - window.innerHeight;
        var initialPosition = window.scrollY;
        var SCROLL_DURATION = 30;
        var step_x = Math.PI / SCROLL_DURATION;
        var step_count = 0;
        function step() {
            if (step_count < SCROLL_DURATION) {
                requestAnimationFrame(step);
                step_count++;
                window.scrollTo(0, initialPosition + targetHeight * 0.25 * Math.pow(1 - Math.cos(step_x * step_count), 2));
            } else if (step_count == SCROLL_DURATION) {
                if (typeof callback == 'function') {
                    callback();
                }
            }
        }
        requestAnimationFrame(step);
    }
}